import React, {useState, useEffect, useCallback, useContext} from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import {
  Card,
  TextField,
  Stack,
  Button,
  MenuItem,
  Container,
  Box,
  Typography,
} from '@mui/material';
// components
import Iconify from '../iconify';
import Scrollbar from '../scrollbar';
// sections
import { EnvelopeListHead, EnvelopeListToolbar } from '../../sections/@dashboard/envelope/index';

import fetchApi from '../../axios/config'

import { EntityContext } from '../../entity';

// ----------------------------------------------------------------------

export default function CreateEnvelope(props) {
    const [envelopeName, setEnvelopeName] = useState('');
    const [newEnvelope, setNewEnvelope] = useState(true);

    const { getEnvelope } = useContext(EntityContext)

    useEffect(() => {
        if (props.envelopeKey) {
            setNewEnvelope(false)
            
            // Buscar nome do envelope apenas uma vez quando envelopeKey mudar
            getEnvelope(props.envelopeKey)
                .then((data) => {
                    if (data && data.envelope) {
                        setEnvelopeName(data.envelope.envelope_name)
                    }
                })
                .catch((error) => {
                    console.error('Erro ao buscar envelope:', error);
                })
        } else {
            setNewEnvelope(true)
            setEnvelopeName('') // Limpar nome quando não há envelopeKey
        }
    }, [props.envelopeKey]) // eslint-disable-line react-hooks/exhaustive-deps
  
    
    const handleSubmission = () => {
        if (envelopeName) {
             props.createEnvelope(envelopeName)
        }
    }

    const handleEnvelopeNameChange = (newEnvelopeName) => {
        setEnvelopeName(newEnvelopeName)
    }

    return (
        <>
        <Helmet>
            <title> Criar Envelope </title>
        </Helmet>

        <Box>
            <Stack 
                spacing={3} 
                sx={{
                    maxWidth: { xs: '100%', sm: 500 },
                    mx: 'auto'
                }}
            >
                <TextField 
                    id="outlined-basic" 
                    label="Nome do envelope" 
                    variant="outlined"
                    value={envelopeName}
                    disabled={!newEnvelope}
                    onChange={e => handleEnvelopeNameChange(e.target.value)}
                    fullWidth
                    required
                    helperText={!envelopeName && newEnvelope ? "Digite um nome para o envelope" : ""}
                />
                {props.envelopeKey ? (
                    <Stack spacing={2}>
                        <Typography variant="body2" color="text.secondary">
                            Envelope criado. Continue adicionando documentos.
                        </Typography>
                        <Button 
                            variant="contained"
                            onClick={() => props.changeStep(1)}
                            fullWidth
                            size="large"
                            startIcon={<Iconify icon="eva:arrow-forward-fill" />}
                        >
                            Continuar para Documentos
                        </Button>
                    </Stack>
                ) : (
                    <Button 
                        variant="contained"
                        onClick={handleSubmission}
                        disabled={!envelopeName}
                        fullWidth
                        size="large"
                        sx={{ mt: 1 }}
                    >
                        Criar envelope
                    </Button>
                )}
            </Stack>
        </Box>
        </>
    );
}
